export enum CheckPoint {
    CP_None=1,
    CP_Green = 10,
    CP_Amber = 50
}